import React, { Component } from 'react';
import applicationRouter from '~/hoc/applicationRouter'
import { inject, observer } from 'mobx-react';
import { Row, Col, OverlayTrigger, Tooltip } from 'react-bootstrap'
import withLocalization from '~/hoc/withLocalization';
import SwitchWidget from '../SwitchWidget';

class shiftRequestSettings extends Component {
    constructor(props) {
        super(props);
        this.state = {
            enableScheduleShiftsCalculations: false,
            enableSchedulePublishUnpublishFeatue: false,
            allowMembersToManageScheduleShift: false,
            disableSwapShift: false,
            disableGrabShift: false,
            disableShiftBonus: false,
            disablePeerShiftView: false,
        }
    }

    componentDidMount() {
        this.loadData();
    }

    loadData = () => {
        const { currentEntity } = this.props.clientStore;
        let { enableScheduleShiftsCalculations, enableSchedulePublishUnpublishFeatue, allowMembersToManageScheduleShift, disableSwapShift, disableGrabShift, disableShiftBonus, disablePeerShiftView } = this.state;
        if (currentEntity.client.data && currentEntity.client.data.basicRules) {
            const basicRules = Object.assign({}, currentEntity.client.data.basicRules);
            enableScheduleShiftsCalculations = basicRules.enableScheduleShiftsCalculations ? basicRules.enableScheduleShiftsCalculations : false;
            enableSchedulePublishUnpublishFeatue = basicRules.enableSchedulePublishUnpublishFeatue ? basicRules.enableSchedulePublishUnpublishFeatue : false;
            allowMembersToManageScheduleShift = basicRules.allowMembersToManageScheduleShift ? basicRules.allowMembersToManageScheduleShift : false;
            disableSwapShift = basicRules.disableSwapShift ? basicRules.disableSwapShift : false;
            disableGrabShift = basicRules.disableGrabShift ? basicRules.disableGrabShift : false;
            disableShiftBonus = basicRules.disableShiftBonus ? basicRules.disableShiftBonus : false;
            disablePeerShiftView = basicRules.disablePeerShiftView ? basicRules.disablePeerShiftView : false;
            this.setState({ enableScheduleShiftsCalculations, enableSchedulePublishUnpublishFeatue, allowMembersToManageScheduleShift, disableSwapShift, disableGrabShift, disableShiftBonus, disablePeerShiftView });
        }
    }

    handleSwitch = (evt, name) => {
        this.props.handleUserDataChange(name, evt);
        this.setState({ [name]: evt })
    }

    render() {
        const { t } = this.props;
        const { enableScheduleShiftsCalculations, enableSchedulePublishUnpublishFeatue, allowMembersToManageScheduleShift, disableSwapShift, disableGrabShift, disableShiftBonus, disablePeerShiftView } = this.state
        const { currentEntity } = this.props.clientStore;
        const allow_work_hours_settings = !!currentEntity.client.data?.basicRules?.workPlanSettings?.allow_work_hours_settings;
        return (
            <div>
                <Row style={{ marginTop: '2rem' }}>
                    <Col sm={1}>
                        <SwitchWidget
                            className="mt-1"
                            value={enableSchedulePublishUnpublishFeatue}
                            onChange={checked => { this.handleSwitch(checked, "enableSchedulePublishUnpublishFeatue") }} />
                    </Col>
                    <Col sm={10}>
                        <label className="control-label me-1">{t('Enable Daily Shift Publish feature')}.</label>
                        <OverlayTrigger
                            placement="right"
                            overlay={
                                <Tooltip id="tooltip-top">
                                    {t("This feature allows the admin/PMs to mark the days of the week as either unpublished or published")}.
                                </Tooltip>
                            }
                        >
                            <i className="fa fa-info-circle text-muted" style={{ opacity: '0.5' }} aria-hidden="true"></i>
                        </OverlayTrigger>
                    </Col>
                </Row>
                <Row style={{ marginTop: '2rem' }}>
                    <Col sm={1}>
                        <SwitchWidget
                            className="mt-1"
                            value={disablePeerShiftView}
                            onChange={checked => { this.handleSwitch(checked, "disablePeerShiftView") }} />
                    </Col>
                    <Col sm={10}>
                        <label className="control-label me-1">{t('Disable peer shift view')}.</label>
                        <OverlayTrigger
                            placement="right"
                            overlay={
                                <Tooltip id="tooltip-top">
                                    {t("If enabled, members will not be able to see the shifts of their colleagues")}.
                                </Tooltip>
                            }
                        >
                            <i className="fa fa-info-circle text-muted" style={{ opacity: '0.5' }} aria-hidden="true"></i>
                        </OverlayTrigger>
                    </Col>
                </Row>
                <Row style={{ marginTop: '2rem' }}>
                    <Col sm={1}>
                        <SwitchWidget
                            className="mt-1"
                            value={disableSwapShift}
                            onChange={checked => { this.handleSwitch(checked, "disableSwapShift") }} />
                    </Col>
                    <Col sm={10}>
                        <label className="control-label me-1">{t('Disable swap shift')}.</label>
                        <OverlayTrigger
                            placement="right"
                            overlay={
                                <Tooltip id="tooltip-top">
                                    {t("If enabled, the swap shift option will not be available")}.
                                </Tooltip>
                            }
                        >
                            <i className="fa fa-info-circle text-muted" style={{ opacity: '0.5' }} aria-hidden="true"></i>
                        </OverlayTrigger>
                    </Col>
                </Row>
                <Row style={{ marginTop: '2rem' }}>
                    <Col sm={1}>
                        <SwitchWidget
                            className="mt-1"
                            value={disableGrabShift}
                            onChange={checked => { this.handleSwitch(checked, "disableGrabShift") }} />
                    </Col>
                    <Col sm={10}>
                        <label className="control-label me-1">{t('Disable grab shift')}.</label>
                        <OverlayTrigger
                            placement="right"
                            overlay={
                                <Tooltip id="tooltip-top">
                                    {t("If enabled, members will not be able to grab the shifts they are invited to")}.
                                </Tooltip>
                            }
                        >
                            <i className="fa fa-info-circle text-muted" style={{ opacity: '0.5' }} aria-hidden="true"></i>
                        </OverlayTrigger>
                    </Col>
                </Row>
                <Row style={{ marginTop: '2rem' }}>
                    <Col sm={1}>
                        <SwitchWidget
                            className="mt-1"
                            value={disableShiftBonus}
                            onChange={checked => { this.handleSwitch(checked, "disableShiftBonus") }} />
                    </Col>
                    <Col sm={10}>
                        <label className="control-label me-1">{t('Disable shift bonus')}.</label>
                        <OverlayTrigger
                            placement="right"
                            overlay={
                                <Tooltip id="tooltip-top">
                                    {t("If enabled, the add bonus option will not be available on shifts")}.
                                </Tooltip>
                            }
                        >
                            <i className="fa fa-info-circle text-muted" style={{ opacity: '0.5' }} aria-hidden="true"></i>
                        </OverlayTrigger>
                    </Col>
                </Row>
                <Row style={{ marginTop: '2rem' }}>
                    <Col sm={1}>
                        <SwitchWidget
                            className="mt-1"
                            value={allowMembersToManageScheduleShift}
                            onChange={checked => { this.handleSwitch(checked, "allowMembersToManageScheduleShift") }} />
                    </Col>
                    <Col sm={10}>
                        <label className="control-label me-1">{t('Allow members to manage schedule shift.')}</label>
                        <OverlayTrigger
                            placement="right"
                            overlay={
                                <Tooltip id="tooltip-top">
                                    {t("If enabled, members can create, edit, and delete their own schedule shifts.")}
                                </Tooltip>
                            }
                        >
                            <i className="fa fa-info-circle text-muted" style={{ opacity: '0.5' }} aria-hidden="true"></i>
                        </OverlayTrigger>
                    </Col>
                </Row>
                {/* This feature will calculate and forecast the shift costing for the week for the Admins/Pms, based on employee payment settings, shift timings, and automatic overtime calculation */}
                <Row style={{ marginTop: '2rem' }}>
                    <Col sm={1}>
                        <SwitchWidget
                            className="mt-1"
                            disabled={true}
                            value={enableScheduleShiftsCalculations}
                            onChange={checked => { this.handleSwitch(checked, "enableScheduleShiftsCalculations") }} />
                    </Col>
                    <Col sm={10}>
                        <label className="control-label me-1">{t('Activate salaries cost calculations')}.</label>
                        <OverlayTrigger
                            placement="right"
                            overlay={
                                <Tooltip id="tooltip-top">
                                    {t("This feature is currently unavailable")}.
                                </Tooltip>
                            }
                        >
                            <i className="fa fa-info-circle text-muted" style={{ opacity: '0.5' }} aria-hidden="true"></i>
                        </OverlayTrigger>
                    </Col>
                </Row>
            </div>
        )
    }

}
export default inject('clientStore', 'commonStore', 'userStore')(applicationRouter(withLocalization(observer(shiftRequestSettings))))